import Popup from '@root/core/components/Popup';
import useTranslate from '@root/core/hooks/useTranslate';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import DetailDescript from '@root/modules/Warehouse/Inquiry/components/DetailDescript';
import { Button, Card, Spin, Typography } from 'antd';
import { createContext, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { ProductContext } from '../../provider/ProductProvider';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import commentService from '@root/core/components/CommentTabs/commentService';
import {
  Comment,
  CommentGroup,
  CommentSide
} from '@root/core/components/CommentTabs/interface';

const ButtonContext = createContext('Download');
export { ButtonContext };

const InquiryDetailPage = () => {
  const [t] = useTranslate();
  const { productId }: any = useParams();
  const [product, setProduct] = useContext<any>(ProductContext);
  const [nameDetail, setNameDetail] = useState([] as any);
  const [productItem, setProductItem] = useState([] as any);
  const [addressDetail, setAddressDetail] = useState([] as any);
  const [statusQuotation, setStatusQuotation] = useState([] as any);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isCanUpdate, setIsCanUpdate] = useState(false);
  const [isOpenUpdatePopup, setIsOpenUpdatePopup] = useState(false);
  const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false);
  const [quotationData, setQuotationData] = useState(false);
  const { Text } = Typography;

  const history = useHistory();

  const Breadcrumb = [
    {
      tittle: '견적 관리',
      url: ''
    },
    {
      tittle: '견적 조회',
      url: '/admin/seller/quote'
    },
    {
      tittle: '견적 상세',
      url: ''
    }
  ];

  const handleDelete = async () => {
    await InquiryServices.removeQuote(productId);
    history.push(`/admin/seller/quote`);
  };
  const handleUpdate = async () => {
    if (quotationData) {
      await InquiryServices.updateQuote(productId, quotationData);
      history.goBack();
    }
  };

  const getListQuotationDetail = async () => {
    const quoteDetail = await InquiryServices.getListQuoteDetail(productId);
    setProduct(quoteDetail.data);
    const list: any[] = [];
    const arrData: any[] = quoteDetail.data.products;
    arrData.forEach((item: any, index: number) => {
      list.push({
        key: index,
        id: item.id,
        productName: item.productName,
        width: item.width,
        height: item.height,
        length: item.length,
        demensionUnit: item.demensionUnit,
        weight: item.weight,
        weightUnit: item.weightUnit,
        estimateQuantity: item.estimateQuantity,
        averageMonthSale: item.averageMonthSale,
        sku: item.sku,
        eanUpc: item.eanUpc,
        asin: item.asin,
        packedMethod: item.packedMethod,
        storageMethod: item.storageMethod,
        dangerousGoods: item.dangerousGoods === true ? 'YES' : 'NO',
        lotProduct:
          item.lotProduct.charAt(0).toUpperCase() + item.lotProduct.slice(1),
        image: item?.image?.url
      });
    });
    setProductItem(list);
    setNameDetail(quoteDetail.data.seller);
    setAddressDetail(quoteDetail.data.warehouse);

    checkCanUpdate(quoteDetail.data.progressStatus === 'SellerApproved');
  };

  let status =
    product.progressStatus === 'WarehouseApproved'
      ? '요청'
      : product.progressStatus === 'New'
      ? '요청'
      : product.progressStatus === 'SellerApproved'
      ? '승인'
      : product.progressStatus === 'Rejected'
      ? '거절'
      : '';

  const checkCanUpdate = async (isApproved: boolean) => {
    if (!isApproved) {
      const comment = await InquiryServices.getQuoteComment(productId);
      const warehouseCommentedFromComment = (comment?.data ?? []).some(
        (c: any) => c.owner === 'Warehouse'
      );
      const comments = await commentService.getComments({
        group: CommentGroup.INQUIRY_DETAIL,
        itemId: productId
      });

      const warehouseCommentedFromCommentAll = comments?.data?.some(
        (c: Comment) => c.side === CommentSide.WAREHOUSE
      );

      if (warehouseCommentedFromComment || warehouseCommentedFromCommentAll) {
        setIsCanUpdate(false);
      } else {
        setIsCanUpdate(true);
      }
    } else {
      setIsCanUpdate(false);
    }
  };

  useEffect(() => {
    getListQuotationDetail();
    setStatusQuotation(status);
  }, [status]);

  const [loadingCmt, setLoadingCmt] = useState(false);
  return (
    <Spin spinning={loadingCmt} className="loading-forgot">
      <ButtonContext.Provider value="Download">
        <BreadcrumbList listBreadcrumb={Breadcrumb} />
        <div className="admin-container">
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div className="header-detail">
              <div className="detail --center">
                <p>물류센터</p>
                <Text keyboard disabled>
                  {addressDetail.name}
                </Text>
              </div>
              <div className="detail">
                <p>물류센터 주소</p>
                <Text keyboard disabled>
                  {addressDetail.googleMapAddress}
                </Text>
              </div>
            </div>

            <div
              className=""
              style={{
                backgroundColor: 'white',
                padding: '30px 10px',
                borderRadius: '6px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 10px 30px',
                  background: 'white',
                  justifyContent: 'space-between'
                }}
              >
                <div style={{ display: 'flex' }}>
                  <p
                    style={{
                      marginBottom: '0px',
                      fontWeight: 'bold',
                      fontSize: '15px'
                    }}
                  >
                    {`${nameDetail.firstName} ${nameDetail.lastName}`}
                  </p>
                  <p
                    style={{
                      marginBottom: '0px',
                      marginLeft: '10px',
                      color: '#747274'
                    }}
                  >
                    {nameDetail.id}
                  </p>
                </div>
                <div className="status-item">{statusQuotation}</div>
              </div>

              {isCanUpdate ? (
                <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                  {!isUpdate ? (
                    <>
                      <Button
                        style={{
                          border: 0,
                          borderBottom: '1px solid gray',
                          padding: '0'
                        }}
                        onClick={() => setIsUpdate(true)}
                      >
                        수정하기
                      </Button>
                      <span style={{ padding: '0 10px' }}>|</span>
                      <Button
                        style={{
                          border: 0,
                          borderBottom: '1px solid gray',
                          padding: '0'
                        }}
                        onClick={() => setIsOpenDeletePopup(true)}
                      >
                        삭제하기
                      </Button>
                    </>
                  ) : (
                    <Button
                      style={{
                        border: 0,
                        borderBottom: '1px solid gray',
                        padding: '0'
                      }}
                      onClick={() => setIsOpenUpdatePopup(true)}
                    >
                      저장하기
                    </Button>
                  )}
                </div>
              ) : null}
              <DetailDescript
                product={product}
                productItem={productItem}
                isUpdate={isUpdate}
                comment
                getListQuotationDetail={getListQuotationDetail}
                onChange={(e: any) => {
                  setQuotationData(e);
                }}
                screenName="SELLER_INQUIRY_DETAIL"
              />
            </div>
          </Card>
        </div>
      </ButtonContext.Provider>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={isOpenUpdatePopup}
        title="저장 하시겠습니까?"
        textCancel="취소"
        textOk="확인"
        action_oke={handleUpdate}
        action_cancel={() => setIsOpenUpdatePopup(false)}
      />
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={isOpenDeletePopup}
        title="삭제 하시겠습니까?"
        textCancel="취소"
        textOk="확인"
        action_oke={handleDelete}
        action_cancel={() => setIsOpenDeletePopup(false)}
      />
    </Spin>
  );
};

export default InquiryDetailPage;
